export const queryKeys = {
  REFERENCE_DATA_FETCH: "referenceData",
  PREMIUM_PROJECTION_FETCH: "premiumProjectionData",
  CREATE_QUOTE: "createQuote",
  QUOTE_DATA_GET: "quoteData",
  PROMO_CODE_GET: "promoCode",
  FIND_SUBURB: "findSuburb",
  GET_PAYMENT_TOKEN: "getPaymentToken",
  GET_SECURECO_PAYMENT_TOKEN: "getSecureCoPaymentToken",
  GET_POLLING_PAYMENT_TOKEN: "getPollingPaymentToken",
  GET_CHECK_PAYMENT_GATEWAY_STATUS: "getCheckPaymentGatewayStatus",
  CLOSE_SECURECO_CONNECTION: "closeSecureCoConnection",
  GET_BANK_BY_BSB: "getBankByBSB",
  GET_AURA_OUTCOME: "getAURAOutcome",
  ORIGINAL_AURA_OUTCOME: "originalAURAOutcome",
  GET_WELCOME_PACK: "getWelcomePacket",
  RETRIEVE_QUOTE_DETAILS_LOADING: "retrieveQuoteDetailsLoading",
  RETRIEVE_QUOTE_TOKEN_DETAIL: "retrieveQuoteTokenDetails",
  CHECK_APP_STATUS: "applicationStatus",
};
